import { CircleBlank, CircleCheck, Error } from '@gusto/workbench-icons';

const PasswordValidator = password => {
  const pass = password.password;
  const hasEightCharacters = pass.length >= 8;
  const hasOneLetter = /[a-zA-Z]/.test(pass);
  const hasOneNumber = /\d/.test(pass);
  const requirementClassName = satisfied => {
    if (pass === '') return 'text-small password-requirement password-requirement--pending';
    return satisfied
      ? 'text-small password-requirement password-requirement--met'
      : 'text-small password-requirement password-requirement--unmet';
  };
  return (
    <div>
      <div>
        {pass === '' && <CircleBlank data-testid="circle-blank" fontSize="14px" />}
        {pass !== '' && hasEightCharacters && (
          <CircleCheck data-testid="circle-check-hasEightCharacters" color="kale.500" />
        )}
        {pass !== '' && !hasEightCharacters && <Error color="error.800" />}{' '}
        <span className={requirementClassName(hasEightCharacters)}>Use 8 or more characters.</span>
      </div>
      <div>
        {pass === '' && <CircleBlank fontSize="14px" />}
        {pass !== '' && hasOneLetter && <CircleCheck color="kale.500" />}
        {pass !== '' && !hasOneLetter && <Error color="error.800" />}{' '}
        <span data-testid="span-error-min-chars" className={requirementClassName(hasOneLetter)}>
          {' '}
          Use a minimum of one letter.
        </span>
      </div>
      <div>
        {pass === '' && <CircleBlank fontSize="14px" />}
        {pass !== '' && hasOneNumber && (
          <CircleCheck data-testid="circle-check-hasOneNumber" color="kale.500" />
        )}
        {pass !== '' && !hasOneNumber && <Error color="error.800" />}{' '}
        <span data-testid="span-error-min-num" className={requirementClassName(hasOneNumber)}>
          Use a minimum of one number.
        </span>
      </div>
    </div>
  );
};

export default PasswordValidator;
